<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-refresh"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Set a new password</h2>
                <p>Choose a strong new password for your Sovos account to complete the reset process.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-key"></i><span>8 to 16 characters required</span></li>
                    <li><i class="fa fa-asterisk"></i><span>Mix letters, numbers and symbols</span></li>
                    <li><i class="fa fa-shield"></i><span>Keep your credentials secure</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="resetForm" class="login-form" autocomplete="off" (ngSubmit)="resetPassword()">
                <h1 class="login-title">Reset password</h1>
                <p class="login-subtitle">Enter your new password below.</p>

                <div class="login-field">
                    <label for="resetPassword">New password</label>
                    <input type="password" class="login-input passdisc" formControlName="newpassword"
                        id="resetPassword" placeholder="New Password" maxlength="16" autocomplete="off"
                        autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div>
                        <span class="login-error"
                            *ngIf="resetForm.get('newpassword').dirty && resetForm.get('newpassword').errors">Invalid Password</span>
                        <span class="login-error"
                            *ngIf="!resetForm.get('newpassword').dirty && resetForm.get('newpassword').errors?.required">Password Required</span>
                    </div>
                </div>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit">SUBMIT</button>
            </form>
        </section>
    </div>
</div>
